export enum fetchKeyResultsTypes {
  Request = 'FETCH_KEY_RESULT_REQUEST',
  Success = 'FETCH_KEY_RESULT_SUCCESS',
  Failed = 'FETCH_KEY_RESULT_FAILED',
}

export enum createKeyResultTypes {
  Request = 'CREATE_KEY_RESULT_REQUEST',
  Success = 'CREATE_KEY_RESULT_SUCCESS',
  Failed = 'CREATE_KEY_RESULT_FAILED',
}

export enum editKeyResultTypes {
  Request = 'EDIT_KEY_RESULT_REQUEST',
  Success = 'EDIT_KEY_RESULT_SUCCESS',
  Failed = 'EDIT_KEY_RESULT_FAILED',
}

export enum deleteKeyResultTypes {
  Request = 'DELETE_KEY_RESULT_REQUEST',
  Success = 'DELETE_KEY_RESULT_SUCCESS',
  Failed = 'DELETE_KEY_RESULT_FAILED',
}

export enum updateKeyResultType {
  Request = 'UPDATE_KEY_RESULT_REQUEST',
  Success = 'UPDATE_KEY_RESULT_SUCCESS',
  Failed = 'UPDATE_KEY_RESULT_FAILED',
}
